import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Meta: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const pathParts = location.pathname
      .split('/')
      .filter((p) => p && !p.startsWith(':')); // Filter out empty strings and route params

    if (pathParts.length > 0) {
      const title = `Kixie - ${pathParts
        .map((part) =>
          part
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
        )
        .join(' - ')}`;
      document.title = title;
    } else {
      document.title = 'Kixie';
    }
  }, [location]);

  return null;
};

export default Meta;